import { addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
import { OptionChainScreens, } from "../entites/iOptionChain";
import { getLimitedData } from "../utils/getLimitedData";
export const optionChainMapper = (data, screen) => {
    if (screen === OptionChainScreens.CHAIN) {
        const mapperData = {
            future: data.ftObj ? mapFutureAndSpot(data.ftObj) : null,
            spot: data.spObj ? mapFutureAndSpot(data.spObj) : null,
            optionChain: mapChainData(data.opChn),
            exchange: data.exc || "",
            maxPain: data.maxPn || "",
            pcr: data.pcr || "",
            lut: data.lut,
        };
        return mapperData;
    }
    else if (screen === OptionChainScreens.CHART ||
        screen === OptionChainScreens.CHANGE ||
        screen === OptionChainScreens.PAIN) {
        return optionChaingGraphMapper(data, screen);
    }
    else if (screen === OptionChainScreens.ALL) {
        return optionChaingGraphMapper(data);
    }
};
const optionChaingGraphMapper = (data, screen) => {
    let optionGraphEntity = {
        OIChart: {
            calls: [],
            puts: [],
            categoriesData: [],
            pcrValue: "",
            maxPainValue: "",
        },
        OIChange: {
            calls: [],
            puts: [],
            categoriesData: [],
            pcrValue: "",
            maxPainValue: "",
        },
        OptionPain: {
            OptionPains: [],
            pcrValue: "",
            maxPainValue: "",
            categoriesData: [],
        },
        spotPrice: data.spObj.ltp,
    };
    if (screen) {
        if (screen === OptionChainScreens.CHART) {
            optionGraphEntity.OIChart = getOIChartGraph(data);
        }
        else if (screen === OptionChainScreens.CHANGE) {
            optionGraphEntity.OIChange = getOIChangeGraph(data);
        }
        else if (screen === OptionChainScreens.PAIN) {
            optionGraphEntity.OptionPain = getOptionPainGraphs(data);
        }
    }
    else {
        optionGraphEntity = {
            OIChart: getOIChartGraph(data),
            OIChange: getOIChangeGraph(data),
            OptionPain: getOptionPainGraphs(data),
            spotPrice: data.spObj.ltp,
        };
    }
    return optionGraphEntity;
};
const getOIChartGraph = (data) => {
    let OIChart = {
        calls: [],
        puts: [],
        pcr: [],
        categoriesData: getCategoriesData(data, 5),
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
    };
    sortData(data, 5).map((opChain) => {
        var _a;
        OIChart.calls.push(parseFloat(opChain.ceQt.opInt));
        OIChart.puts.push(parseFloat(opChain.peQt.opInt));
        (_a = OIChart === null || OIChart === void 0 ? void 0 : OIChart.pcr) === null || _a === void 0 ? void 0 : _a.push(parseFloat(opChain.pcr));
    });
    return OIChart;
};
const getCategoriesData = (data, limit) => {
    let spotPrice = data.spObj.ltp;
    let minArray = [], maxArray = [], finalArray = [];
    data.opChn.map((opChn) => {
        if (opChn.stkPrc < spotPrice) {
            minArray.push(addCommasWithoutDecimal(opChn.stkPrc));
        }
        else {
            maxArray.push(addCommasWithoutDecimal(opChn.stkPrc));
        }
    });
    if (!!limit && limit > 0) {
        finalArray.push(...getLimitedData(minArray, limit, true), ...getLimitedData(maxArray, limit));
    }
    else {
        finalArray.push(...minArray, ...maxArray);
    }
    return finalArray;
};
const getOIChangeGraph = (data) => {
    let OIChange = {
        calls: [],
        puts: [],
        categoriesData: getCategoriesData(data, 5),
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
    };
    sortData(data, 5).map((opChain) => {
        OIChange.calls.push(-1 * parseFloat(opChain.ceQt.opIntChg));
        OIChange.puts.push(parseFloat(opChain.peQt.opIntChg));
    });
    return OIChange;
};
const getOptionPainGraphs = (data) => {
    let OptionPain = {
        OptionPains: [],
        pcrValue: data.pcr,
        maxPainValue: data.maxPn,
        categoriesData: getCategoriesData(data, 5),
    };
    sortData(data, 5).map((opChain) => {
        OptionPain.OptionPains.push(parseFloat(opChain.optPn));
    });
    return OptionPain;
};
const sortData = (data, limit) => {
    let spotPrice = data.spObj.ltp;
    let minArray = [], maxArray = [], finalArray = [];
    data.opChn.map((opChn) => {
        if (opChn.stkPrc < spotPrice) {
            minArray.push(opChn);
        }
        else {
            maxArray.push(opChn);
        }
    });
    if (!!limit && limit > 0) {
        finalArray.push(...getLimitedData(minArray, limit, true), ...getLimitedData(maxArray, limit));
    }
    else {
        finalArray.push(...minArray, ...maxArray);
    }
    return finalArray;
};
function mapChainData(from) {
    let list = from.map((item) => {
        return {
            ATM: item.ATM || "",
            optionPain: item.optPn || "",
            pcr: item.pcr || "",
            strikePrice: item.stkPrc || "",
            vtySkw: item.vtySkw || "",
            call: mapCallAndPut(item.ceQt),
            put: mapCallAndPut(item.peQt),
        };
    });
    return list;
}
const mapFutureAndSpot = (list) => {
    return {
        change: list.chg ? list.chg : "",
        changePercentage: list.chgP ? list.chgP : "",
        expiry: list.exp ? list.exp : "",
        expiryFlag: list.expFlg ? list.expFlg : false,
        latestTradingPrice: list.ltp ? list.ltp : "",
        symbol: list.sym ? list.sym : "",
    };
};
const mapCallAndPut = (list) => {
    return {
        askSize: list.akSz ? list.akSz : "",
        askPrice: list.askPr ? list.askPr : "",
        askIvFuture: list.askivfut ? list.askivfut : "",
        askIvSpot: list.askivspt ? list.askivspt : "",
        bidSize: list.bdSz ? list.bdSz : "",
        bidPrice: list.bidPr ? list.bidPr : "",
        bidIvFuture: list.bidivfut ? list.bidivfut : "",
        bidIvSpot: list.bidivspt ? list.bidivspt : "",
        close: list.c ? list.c : "",
        change: list.chg ? list.chg : "",
        changePercentage: list.chgP ? list.chgP : "",
        delta: list.delta ? list.delta : "",
        expiryFlag: list.expFlg ? list.expFlg : false,
        gamma: list.gamma ? list.gamma : "",
        high: list.h ? list.h : "",
        low: list.l ? list.l : "",
        latestTradingPrice: list.ltp ? list.ltp : "",
        ltpIvFuture: list.ltpivfut ? list.ltpivfut : "",
        ltpIvSpot: list.ltpivspt ? list.ltpivspt : "",
        open: list.o ? list.o : "",
        openInterest: list.opInt ? list.opInt : "",
        openInterestChange: list.opIntChg ? list.opIntChg : "",
        symbol: list.sym ? list.sym : "",
        theta: list.theta ? list.theta : "",
        tradeSymbol: list.trdSym ? list.trdSym : "",
        vega: list.vega ? list.vega : "",
        volume: list.vol ? addCommasWithoutDecimal(list.vol) : "",
        priceOiAnalysis: list.prcOIA ? list.prcOIA : "-",
    };
};
